// footer copyright date year
window.onload = function() {
	document.getElementById("copyright_year").innerHTML = new Date().getFullYear();
}